import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/@pauliescanlon/gatsby-theme-terminal/src/layouts/PageLayout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SourceList = makeShortcode("SourceList");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Posts`}</h1>
    <p>{`This is `}<inlineCode parentName="p">{`src/pages/posts.mdx`}</inlineCode></p>
    <p>{`Here we use the `}<inlineCode parentName="p">{`<SourceList />`}</inlineCode>{` to list files found in `}<inlineCode parentName="p">{`posts`}</inlineCode></p>
    <SourceList mdxType="SourceList">
  {source => <ul>
      {source.map((edge, index) => {
          const {
            frontmatter: {
              title
            },
            fields: {
              slug
            }
          } = edge.node;
          return <li key={index}>
            <a href={slug}>{title}</a>
          </li>;
        })}
    </ul>}
    </SourceList>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      